import alien from "../Pictures/alien.png";
import purple3DAlien from "../Pictures/purpledAlien.png";
import React from "react";

function Profile() {
  return (
    <div className="profile">
      <div className="profile-stats">
        <div className="profile-address"></div>
        <div className="profile-shipBattery-bar"></div>
        <div className="profile-shipBattery"></div>
      </div>
      <div className="profile-picture-container">
        <img className="profile-picture-alien" src={alien} alt="" />
      </div>
    </div>
  );
}

export default Profile;
